import Box from "@mui/material/Box";

const VersoMebelLogo = ({
    height = 48,
    href = "/",
    textSizeScale = 0.58,
    fontWeight = 500,
    sx = {},
}) => (
    <Box
        component="a"
        href={href}
        sx={{
            display: "inline-flex",
            alignItems: "center",
            flexShrink: 0,
            textDecoration: "none",
            ...sx,
        }}
    >
        <Box
            component="span"
            aria-label="VersoМебель"
            sx={{
                display: "inline-flex",
                alignItems: "baseline",
                fontFamily: "Manrope, Roboto, Arial, sans-serif",
                fontWeight,
                letterSpacing: "0.08em",
                fontSize: height * textSizeScale,
                lineHeight: 1,
                whiteSpace: "nowrap",
                color: (theme) => theme.palette.primary.main,
            }}
        >
            <Box component="span">Verso</Box>
            <Box component="span">Mebel</Box>
        </Box>
    </Box>
);

export default VersoMebelLogo;
